var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError401(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "error401",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 226 197",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#999fa7}.st4{fill:#f01f7a}.st5{fill:#d10d62}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fill: "#c7cbd1",
    fillOpacity: 0.737,
    d: "M0 174.2h226v-146H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    className: "st1",
    d: "M8.8 35.8c0-1.3-1.1-2.4-2.4-2.4S4 34.5 4 35.8s1.1 2.4 2.4 2.4 2.4-1.1 2.4-2.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st1",
    d: "M15.4 35.8c0-1.3-1.1-2.4-2.4-2.4-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4c1.3 0 2.4-1.1 2.4-2.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st1",
    d: "M21.8 35.8c0-1.3-1.1-2.4-2.4-2.4-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4c1.3 0 2.4-1.1 2.4-2.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    fill: "#fff",
    d: "M3.9 53.2h217.6v-11H3.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M112.7 89.8C111.5 89.4 84.8 49 84.8 49L59.7 12.1S84.6 9.2 99.8 7C115 4.8 136.4.1 136.4.1l-10.7 42-13 47.7z",
    fill: "#ff549e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "st4",
    d: "M124.2 41.4l-11.5 48.4 46.6-24.1 37-22.3s-24.2-14.7-31.7-20.2C157 17.7 136.3 0 136.3 0s-4 13.8-12.1 41.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "st5",
    d: "M112.6 89.2L160 63.5l36.4-20.1s2.1 23.4 4.7 34.8c2.5 11.4 9.9 42.4 9.9 42.4l-54.4-18.1-44-13.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "M112.4 88.7l53.3 16.1 45.1 15.5s-18.3 22.4-23.9 30.9c-5.6 8.5-21.7 34.8-21.7 34.8l-25.9-46.9-26.9-50.4z",
    fill: "#c60559"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    className: "st5",
    d: "M112.3 89l29.8 50.3 23.1 46.6s-19.8.1-37.6 2.3c-17.8 2.3-40.3 7.9-40.3 7.9l11.9-52.3L112.3 89z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "st4",
    d: "M21.8 147.7l43.8-29.6 47.6-28.9-13.1 56.7-12.8 50.3s-1.5-2-3.7-3.9-25.2-19.1-30.2-22.5c-4.9-3.5-31.6-22.1-31.6-22.1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    className: "st4",
    d: "M113.8 89.1l-54.9-11s-41.1-6.5-47.9-6c.1.6 6.5 19.9 8.7 37.8s2.2 37.8 2.2 37.8 15.9-9.6 47.6-28.8l44.3-29.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    d: "M112.8 88.7L86.6 50.6 59.7 12.1C58.8 15 48 29 37.5 41.3S11 72.1 11 72.1L65.2 81l47.6 7.7z",
    fill: "#ff6aaa"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    d: "M115.8 89c-.1-1.7-1.6-3-3.3-2.9-1.7.1-3 1.6-2.9 3.4.1 1.7 1.6 3 3.3 2.9 1.7-.1 3-1.6 2.9-3.4",
    fill: "#c6c4c5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M111 92c1.4.8 3.2.4 4.1-.9.9-1.2.7-2.8-.2-3.9.1 0 .2.1.2.2 1.4 1 1.8 3 .8 4.4-1 1.4-3 1.8-4.4.8-.1-.2-.3-.4-.5-.6z",
    fill: "#68737e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError401);
export default __webpack_public_path__ + "static/media/error-401.915e250c8538f04722d4419026a6e97c.svg";
export { ForwardRef as ReactComponent };